import React from 'react';
import Icon from './Icon';

// Compact page list: first, last, and the current page's neighbours, with
// gaps standing in for the rest — e.g. [1, 2, 3, 'gap-9', 9].
export const pageItems = (page, pageCount) => {
  const pages = new Set([1, pageCount, page - 1, page, page + 1]);
  const sorted = [...pages].filter((n) => n >= 1 && n <= pageCount).sort((a, b) => a - b);
  const out = [];
  sorted.forEach((n, i) => {
    if (i > 0 && n - sorted[i - 1] > 1) out.push(`gap-${n}`);
    out.push(n);
  });
  return out;
};

// Previous · 1 2 … 9 · Next. Renders nothing for a single page.
const Pager = ({ page, pageCount, onChange, label = 'Pages' }) => {
  if (pageCount <= 1) return null;
  return (
    <nav className="pm-pager" aria-label={label}>
      <button
        type="button"
        className="pm-pager-btn"
        disabled={page === 1}
        onClick={() => onChange(page - 1)}
      >
        <Icon name="chevron-left" size={14} />
        Previous
      </button>
      {pageItems(page, pageCount).map((item) =>
        typeof item === 'number' ? (
          <button
            key={item}
            type="button"
            className="pm-pager-btn"
            aria-current={item === page ? 'page' : undefined}
            onClick={() => onChange(item)}
          >
            {item}
          </button>
        ) : (
          <span key={item} className="pm-pager-gap">…</span>
        )
      )}
      <button
        type="button"
        className="pm-pager-btn"
        disabled={page === pageCount}
        onClick={() => onChange(page + 1)}
      >
        Next
        <Icon name="chevron-right" size={14} />
      </button>
    </nav>
  );
};

export default Pager;
